"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcMenuV2MegaMenu = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var bc_menu_v2_constants_1 = require("./bc-menu-v2-constants");
var BcMenuV2MegaMenu = (function () {
    function BcMenuV2MegaMenu(elementsMenuMenus, configHeaderMegaMenu, deleteClassActiveMegaMenu, deleteClassPressItems, toogleOpenCloseMegaMenu, megaMenuButton) {
        this.configHeaderMegaMenu = configHeaderMegaMenu;
        this.deleteClassPressItems = deleteClassPressItems;
        this.deleteClassActiveMegaMenu = deleteClassActiveMegaMenu;
        this.toogleOpenCloseMegaMenu = toogleOpenCloseMegaMenu;
        this.megaMenuButton = megaMenuButton;
        this.render(elementsMenuMenus);
    }
    BcMenuV2MegaMenu.prototype.render = function (elementsMenuMenus) {
        this.createMegamenu(elementsMenuMenus);
    };
    BcMenuV2MegaMenu.prototype.createMegamenu = function (elementsMenuMenus) {
        var _this = this;
        elementsMenuMenus.forEach(function (subMenu) {
            var megaMenu = subMenu.querySelector(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MEGA_MENU_V2));
            if (megaMenu) {
                var headerMegaMenu = megaMenu.insertBefore(_this.createElementHtml(common_constants_1.BcCommonConstants.SECTION_TAG), megaMenu.firstChild);
                var buttonElement = headerMegaMenu.appendChild(_this.createHTMLElement({
                    tag: common_constants_1.BcCommonConstants.BUTTON_TAG,
                    classList: [
                        common_constants_1.BcCommonConstants.BC_ICON_BUTTON_TAG,
                        common_constants_1.BcCommonConstants.BC_ICON_BUTTON_GHOST_CLASS,
                        common_constants_1.BcCommonConstants.BC_ICON_BUTTON_MEDIUM_CLASS,
                    ],
                }));
                buttonElement.setAttribute(common_constants_1.BcCommonConstants.ARIA_LABEL, bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MEGA_MENU_V2_3_BUTTON_CLOSE);
                _this.configHeaderMegaMenu(subMenu, headerMegaMenu, true, common_constants_1.BcCommonConstants.ICON_ERROR, false, buttonElement);
                _this.titleMegaMenuSubgroup(megaMenu);
                _this.openCloseMegaMenu(subMenu);
                _this.resizeWidthMegaMenu(megaMenu);
            }
            window.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_DOWN, function (event) {
                if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ESCAPE) {
                    _this.deleteClassPressItems();
                    _this.deleteClassActiveMegaMenu();
                }
            });
        });
    };
    BcMenuV2MegaMenu.prototype.createHTMLElement = function (conf) {
        var element = document.createElement(conf.tag);
        conf.classList &&
            conf.classList.forEach(function (c) {
                element.classList.add(c);
            });
        conf.attributes &&
            conf.attributes.forEach(function (attr) {
                element.setAttribute(attr.name, attr.value);
            });
        return element;
    };
    BcMenuV2MegaMenu.prototype.createElementHtml = function (element) {
        return document.createElement(element);
    };
    BcMenuV2MegaMenu.prototype.titleMegaMenuSubgroup = function (megaMenu) {
        var _this = this;
        var subGroups = megaMenu.querySelectorAll(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MEGA_MENU_V2_SUBGROUP));
        subGroups.forEach(function (element) {
            var headerMegaMenuSubGroup = element.insertBefore(_this.createElementHtml(common_constants_1.BcCommonConstants.SECTION_TAG), element.firstChild);
            var titleAtribute = element.getAttribute(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_ATR_TITLE);
            var spanElement = headerMegaMenuSubGroup.appendChild(_this.createElementHtml(common_constants_1.BcCommonConstants.SPAN_TAG));
            spanElement.innerText = titleAtribute;
        });
    };
    BcMenuV2MegaMenu.prototype.openCloseMegaMenu = function (subMenu) {
        var _this = this;
        var megaMenu = subMenu.querySelector(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MEGA_MENU_V2));
        subMenu
            .querySelector(common_constants_1.BcCommonConstants.SECTION_TAG)
            .querySelector(common_constants_1.BcCommonConstants.DIV_TAG)
            .querySelector(common_constants_1.BcCommonConstants.EM_TAG)
            .setAttribute(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_DATA_TOOGLE, bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TOOGLE);
        subMenu
            .querySelector(common_constants_1.BcCommonConstants.SECTION_TAG)
            .querySelector(common_constants_1.BcCommonConstants.DIV_TAG)
            .querySelector(common_constants_1.BcCommonConstants.SPAN_TAG)
            .setAttribute(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_DATA_TOOGLE, bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TOOGLE);
        subMenu.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
            var toogleOpenClose = event.target.getAttribute(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_DATA_TOOGLE);
            if (toogleOpenClose == bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TOOGLE) {
                _this.toogleOpenCloseMegaMenu(subMenu);
            }
        });
        this.megaMenuButton = megaMenu.querySelector("".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MEGA_MENU_V2_CLOSE_BUTTON));
        this.megaMenuButton.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            _this.buttonOpenCloseMegaMenu(subMenu);
        });
        this.megaMenuButton.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_DOWN, function (event) {
            var allowedKeyCodes = [common_constants_1.BcCommonConstants.KEY_EVENT_ENTER];
            if (allowedKeyCodes.includes(event.code)) {
                _this.keyboardOpenCloseMegaMenu(subMenu);
            }
        });
    };
    BcMenuV2MegaMenu.prototype.resizeWidthMegaMenu = function (megaMenu) {
        var megaMenuContent = megaMenu.querySelectorAll(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MEGA_MENU_V2_CONTENT));
        switch (megaMenuContent.length) {
            case common_constants_1.COMMON_CONSTANTS_NUMBERS.N1:
                megaMenu.style.width = bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MEGA_MENU_V2_COLUMN;
                break;
            case common_constants_1.COMMON_CONSTANTS_NUMBERS.N2:
                megaMenu.style.width = bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MEGA_MENU_V2_COLUMNS;
                break;
            case common_constants_1.COMMON_CONSTANTS_NUMBERS.N3:
                megaMenu.style.width = bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MEGA_MENU_V2_3_COLUMNS;
                break;
            default:
                break;
        }
    };
    BcMenuV2MegaMenu.prototype.buttonOpenCloseMegaMenu = function (liElement) {
        var megaMenu = liElement.querySelector(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MEGA_MENU_V2));
        megaMenu.classList.remove(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MEGA_MENU_V2_ACTIVE);
        this.deleteClassPressItems();
    };
    BcMenuV2MegaMenu.prototype.keyboardOpenCloseMegaMenu = function (liElement) {
        var megaMenu = liElement.querySelector(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MEGA_MENU_V2));
        if (megaMenu.classList.contains(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MEGA_MENU_V2_ACTIVE)) {
            megaMenu.classList.remove(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MEGA_MENU_V2_ACTIVE);
            liElement.classList.remove(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_SUBMENU_V2_ACTIVE);
        }
        else {
            this.deleteClassActiveMegaMenu();
            megaMenu.classList.add(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MEGA_MENU_V2_ACTIVE);
            liElement.classList.add(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_SUBMENU_V2_ACTIVE);
            liElement.parentElement.setAttribute(common_constants_1.BcCommonConstants.ARIA_CURRENT, bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TRUE);
            liElement.parentElement.setAttribute(common_constants_1.BcCommonConstants.ARIA_EXPANDED, bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TRUE);
        }
    };
    return BcMenuV2MegaMenu;
}());
exports.BcMenuV2MegaMenu = BcMenuV2MegaMenu;
